import { ApolloLink } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';

export default class SubscriptionWsLink extends ApolloLink {
  constructor(client) {
    super();
    this.client = new GraphQLWsLink(client);
  }
  request(operation) {
    const context = operation.getContext();
    operation.service = context?.serviceName;
    return this.client.request(operation);
  }
}
